import React from 'react';
import styled from 'styled-components';

export const StyledTypography = styled.div`
  font-family: var(--font-family);
  font-size: 14px;
  color: #2b2b2b;
`;

const TextLine: React.FC = ({ children, ...rest }) => {
  return <StyledTypography {...rest}>{children}</StyledTypography>;
};

export default TextLine;
